import axios from "axios";
import Auth from "./auth";

  // Axios instance with an interceptor for handling authentication
  export const axiosInstance = axios.create();

  axiosInstance.defaults.baseURL = process.env.REACT_APP_API_URL;

//   axiosInstance.interceptors.request.use(
//     (config) => {
//       // Check if a token exists in local storage
//       const token = Auth.token;
//       if (token) {
//         // If a token exists, add it to the request headers
//         config.headers.Authorization = `Bearer ${token}`;
//       }
//       return config;
//     },
//     (error) => {
//       return Promise.reject(error);
//     }
//   );

  // request interceptor function
export const requestInterceptor = (request) => {
    if (Auth.token) {
      request.headers.Authorization = `Bearer ${Auth.token}`;
    }
    return request;
  };

  // response interceptor function for error
export const errorHandler = (error) => {
    if (error?.response?.status === 401) {
      console.log("EXPIRED", error?.response);
      Storage.setFlash("error_message", "Session expired, please login again.");
      Auth.logout();
    }
   
   
    Notification.error(error?.response?.data?.message);
   
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({ ...error });
  };
   
  // response interceptor function for success
  export const successHandler = (response) => response;